import classNames from 'classnames'

import {
  EMPTY_STRING,
  FLOATING_ELEMENT_PLACEMENT,
} from '../../../../constants/common'
import { useClampingTextMeasure } from '../../../ClampingText'
import { FloatingTooltip } from '../../../Floating'
import { Headline2 } from '../../../Headline2'
import { Skeleton } from '../../../Skeleton'
import { EntityProfileHeaderTextButton } from '../../EntityProfileHeaderTextButton'
import { EntityProfileHeaderTextTail } from '../EntityProfileHeaderTextTail'

import * as styles from '../EntityProfileHeaderText.module.css'

function EntityProfileHeaderTextClamped({
  EditButton = EntityProfileHeaderTextButton,
  additionalIcons,
  clampLines,
  className = styles.clampedRoot,
  editButtonQaName,
  isArchived,
  isEditButtonHoverVisible,
  isLoading,
  text,
  textPlaceholder,
  tooltipPlacement = FLOATING_ELEMENT_PLACEMENT.top,
  onClickEditButton,
}) {
  const fullText = text || textPlaceholder || EMPTY_STRING

  const {
    content,
    isTruncated,
    measureRef,
    measureTailRef,
    measureTextRef,
    rootRef,
  } = useClampingTextMeasure({
    clampingLinesCount: clampLines,
    fullText,
  })

  const isSecondary = !text && Boolean(textPlaceholder)

  const titleGroupClassName = classNames(styles.titleGroup, {
    [styles.loading]: isLoading,
  })

  return (
    <FloatingTooltip
      content={text}
      disabled={!text || !isTruncated}
      placement={tooltipPlacement}
    >
      <div
        className={className}
        ref={rootRef}
        style={{ '--clamp-lines': clampLines }}
      >
        {isLoading ? null : (
          <div className={classNames(styles.titleGroup, styles.measure)}>
            <Headline2 className={styles.titleText} ref={measureRef}>
              <span ref={measureTextRef}>{fullText}</span>
              <EntityProfileHeaderTextTail
                isMeasure
                EditButton={null}
                additionalIcons={additionalIcons}
                isArchived={isArchived}
                tailRef={measureTailRef}
              />
            </Headline2>
            {EditButton ? (
              <EditButton isMeasure className={styles.editButton} />
            ) : null}
          </div>
        )}
        <div className={titleGroupClassName}>
          {isLoading ? (
            <Skeleton className={styles.skeleton} />
          ) : (
            <>
              <Headline2
                className={classNames(styles.titleText, styles.clampedText)}
                isSecondary={isSecondary}
              >
                {content}
                <EntityProfileHeaderTextTail
                  EditButton={null}
                  additionalIcons={additionalIcons}
                  isArchived={isArchived}
                />
              </Headline2>
              {EditButton ? (
                <EditButton
                  className={classNames(styles.editButton, {
                    [styles.editButtonHoverVisible]: isEditButtonHoverVisible,
                  })}
                  qaName={editButtonQaName}
                  onClick={onClickEditButton}
                />
              ) : null}
            </>
          )}
        </div>
      </div>
    </FloatingTooltip>
  )
}

export default EntityProfileHeaderTextClamped
